var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    viewBox: "0 0 268.152 273.883"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0fbc5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0cba65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#0fbc5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#0fbc5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#0fbc5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#0fbc5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#12bc58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#28bf3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#38c02b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#52c218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#67c30f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86c504"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#1abd4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#6ec30d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#8ac502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#a2c600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#c8c903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ebcb03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#f7cd07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#fdcd04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#fdce05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#ffce0a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#ff4c3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#ff692c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#ff7825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#ff8d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9f13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#ff4541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#ff4540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#ff4640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ff473f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#ff5138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#ff5b33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#ff6c29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8c18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#fb4e5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#0cba65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0bb86d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#09b479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#08ad93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#0aa6a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#0d9cc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#1893dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#258bf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#3086ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#ff4e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#ff8a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ffa312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#ffb60c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#ffcd0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#fecf0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#fecf08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdcd01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#google_svg__a",
    id: "google_svg__s",
    x1: 219.7,
    x2: 254.467,
    y1: 329.535,
    y2: 329.535,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#google_svg__b",
    id: "google_svg__m",
    cx: 109.627,
    cy: 135.862,
    r: 71.46,
    fx: 109.627,
    fy: 135.862,
    gradientTransform: "matrix(-1.93688 1.043 1.45573 2.55542 290.525 -400.634)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#google_svg__c",
    id: "google_svg__n",
    cx: 45.259,
    cy: 279.274,
    r: 71.46,
    fx: 45.259,
    fy: 279.274,
    gradientTransform: "matrix(-3.5126 -4.45809 -1.69255 1.26062 870.8 191.554)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#google_svg__d",
    id: "google_svg__l",
    cx: 304.017,
    cy: 118.009,
    r: 47.854,
    fx: 304.017,
    fy: 118.009,
    gradientTransform: "matrix(2.06435 0 0 2.59204 -297.679 -151.747)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#google_svg__e",
    id: "google_svg__o",
    cx: 181.001,
    cy: 177.201,
    r: 71.46,
    fx: 181.001,
    fy: 177.201,
    gradientTransform: "matrix(-.24858 2.08314 2.96249 .33417 -255.146 -331.164)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#google_svg__f",
    id: "google_svg__p",
    cx: 207.673,
    cy: 108.097,
    r: 41.102,
    fx: 207.673,
    fy: 108.097,
    gradientTransform: "matrix(-1.2492 1.34326 -3.89684 -3.4257 880.501 194.905)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#google_svg__g",
    id: "google_svg__r",
    cx: 109.627,
    cy: 135.862,
    r: 71.46,
    fx: 109.627,
    fy: 135.862,
    gradientTransform: "matrix(-1.93688 -1.043 1.45573 -2.55542 290.525 838.683)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#google_svg__h",
    id: "google_svg__j",
    cx: 154.87,
    cy: 145.969,
    r: 71.46,
    fx: 154.87,
    fy: 145.969,
    gradientTransform: "matrix(-.0814 -1.93722 2.92674 -.11625 -215.135 632.86)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "google_svg__q",
    width: 1.097,
    height: 1.116,
    x: -0.048,
    y: -0.058,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.701
  })), /*#__PURE__*/React.createElement("filter", {
    id: "google_svg__k",
    width: 1.033,
    height: 1.02,
    x: -0.017,
    y: -0.01,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.242
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "google_svg__i",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.378 193.24H237.083v53.438h77.167c-1.241 7.563-4.026 15.003-8.105 21.786-4.674 7.773-10.451 13.69-16.373 18.196-17.74 13.498-38.42 16.258-52.783 16.258-36.283 0-67.283-23.286-79.285-54.928-.484-1.149-.805-2.335-1.197-3.507a81.1 81.1 0 0 1-4.101-25.448c0-9.226 1.569-18.057 4.43-26.398 11.285-32.897 42.985-57.467 80.179-57.467 7.481 0 14.685.884 21.517 2.648a77.67 77.67 0 0 1 33.425 18.25l40.834-39.712c-24.839-22.616-57.219-36.32-95.844-36.32-30.878 0-59.386 9.553-82.748 25.7-18.945 13.093-34.483 30.625-44.97 50.985-9.753 18.879-15.094 39.8-15.094 62.294 0 22.495 5.35 43.633 15.103 62.337v.126c10.302 19.857 25.368 36.954 43.678 49.988 15.997 11.386 44.68 26.551 84.031 26.551 22.63 0 42.687-4.051 60.375-11.644 12.76-5.478 24.065-12.622 34.301-21.804 13.525-12.132 24.117-27.139 31.347-44.404s11.097-36.79 11.097-57.957c0-9.858-.998-19.87-2.689-28.968Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__i)",
    transform: "matrix(.95792 0 0 .98525 -90.174 -78.856)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#google_svg__j)",
    d: "M92.076 219.959c.148 22.14 6.501 44.982 16.117 63.423v.127c6.949 13.392 16.445 23.97 27.26 34.452l65.327-23.67c-12.36-6.235-14.246-10.055-23.105-17.026-9.054-9.066-15.802-19.473-20.004-31.677h-.17l.17-.127c-2.765-8.058-3.037-16.613-3.14-25.503Z",
    filter: "url(#google_svg__k)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google_svg__l)",
    d: "M237.084 79.025c-6.457 22.526-3.989 44.421 0 57.161 7.456.006 14.638.888 21.449 2.647a77.66 77.66 0 0 1 33.424 18.25l41.88-40.726c-24.81-22.59-54.667-37.296-96.754-37.332",
    filter: "url(#google_svg__k)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google_svg__m)",
    d: "M236.943 78.847c-31.67 0-60.91 9.798-84.871 26.359a145.5 145.5 0 0 0-24.332 21.15c-1.904 17.744 14.257 39.551 46.262 39.37 15.528-17.936 38.495-29.542 64.056-29.542l.07.002-1.044-57.335q-.07-.002-.14-.004",
    filter: "url(#google_svg__k)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google_svg__n)",
    d: "m341.475 226.379-28.268 19.285c-1.24 7.562-4.028 15.002-8.107 21.786-4.674 7.772-10.45 13.69-16.373 18.196-17.702 13.47-38.328 16.244-52.687 16.255-14.842 25.102-17.444 37.675 1.043 57.934 22.877-.016 43.157-4.117 61.046-11.796 12.931-5.551 24.388-12.792 34.761-22.097 13.706-12.295 24.442-27.503 31.769-45s11.245-37.282 11.245-58.734Z",
    filter: "url(#google_svg__k)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3086ff",
    d: "M234.996 191.21v57.498h136.006c1.196-7.874 5.152-18.064 5.152-26.5 0-9.858-.996-21.899-2.687-30.998Z",
    filter: "url(#google_svg__k)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google_svg__o)",
    d: "M128.39 124.327c-8.394 9.119-15.564 19.326-21.249 30.364-9.753 18.879-15.094 41.83-15.094 64.324 0 .317.026.627.029.944 4.32 8.224 59.666 6.649 62.456 0-.004-.31-.039-.613-.039-.924 0-9.226 1.57-16.026 4.43-24.367 3.53-10.289 9.056-19.763 16.123-27.926 1.602-2.031 5.875-6.397 7.121-9.016.475-.997-.862-1.557-.937-1.908-.083-.393-1.876-.077-2.277-.37-1.275-.929-3.8-1.414-5.334-1.845-3.277-.921-8.708-2.953-11.725-5.06-9.536-6.658-24.417-14.612-33.505-24.216",
    filter: "url(#google_svg__k)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google_svg__p)",
    d: "M162.099 155.857c22.112 13.301 28.471-6.714 43.173-12.977l-25.574-52.664a144.7 144.7 0 0 0-26.543 14.504c-12.316 8.512-23.192 18.9-32.176 30.72Z",
    filter: "url(#google_svg__q)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google_svg__r)",
    d: "M171.099 290.222c-29.683 10.641-34.33 11.023-37.062 29.29a145 145 0 0 0 16.792 13.984c15.996 11.386 46.766 26.551 86.118 26.551.046 0 .09-.004.137-.004v-59.157l-.094.002c-14.736 0-26.512-3.843-38.585-10.527-2.977-1.648-8.378 2.777-11.123.799-3.786-2.729-12.9 2.35-16.183-.938",
    filter: "url(#google_svg__k)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google_svg__s)",
    d: "M219.7 299.023v59.996c5.506.64 11.236 1.028 17.247 1.028 6.026 0 11.855-.307 17.52-.872v-59.748a105 105 0 0 1-17.477 1.461c-5.932 0-11.7-.686-17.29-1.865",
    filter: "url(#google_svg__k)",
    opacity: 0.5
  }))));
};
export default SvgGoogle;